import {
  HeaderParams,
  KpiParams,
  ListParams,
  PagedResult,
  ProviderCoderHeader,
  ProviderCoderKpis,
  RiskArea,
} from "../types";
import { buildHeaderQuery, buildKpiQuery } from "./query-builder";
import { callEnterpriseApi } from "./enterprise-api";
import { fetchAllRows, fetchList } from "./billing-risks-service";

// The four v1 endpoints behind the New Provider & Coder Risks tab. Plain
// promise-returning functions; ./risk-areas-api wraps each one in an RTK Query
// endpoint, and status-counts-service calls fetchProviderCoderHeaders directly.

const get = callEnterpriseApi;

const PROVIDERS_URL = "/api/v1/risk-areas/provider-coder/providers";
const CODERS_URL = "/api/v1/risk-areas/provider-coder/coders";

// 4. Paginated new-provider risk list.
export const fetchProviderRisks = (params: ListParams): Promise<PagedResult<RiskArea>> =>
  fetchList(PROVIDERS_URL, params);

// 5. Paginated new-coder risk list. Coder rows are grouped by coder, so the
// group filter goes out as CoderGroup (RefCoderGroupId) — ProviderGroup ids
// mean nothing to this endpoint.
export const fetchCoderRisks = (params: ListParams): Promise<PagedResult<RiskArea>> =>
  fetchList(CODERS_URL, params, "CoderGroup");

// 4b / 5b. Every row behind the current filters, for bulk selection only.
export const fetchAllProviderRows = (params: ListParams): Promise<RiskArea[]> =>
  fetchAllRows(PROVIDERS_URL, params);

export const fetchAllCoderRows = (params: ListParams): Promise<RiskArea[]> =>
  fetchAllRows(CODERS_URL, params, "CoderGroup");

// 6. Entity-group headers (quarter + filters; SP emits the Provider/Coder rows).
// Takes both providerGroupIds and coderIds and returns both groups in one
// response — see fetchBillingHeaders for why status-counts-service calls this
// directly with groupBy=Status.
export const fetchProviderCoderHeaders = async (
  params: HeaderParams
): Promise<ProviderCoderHeader[]> => {
  const response = (await get(
    `/api/v1/risk-areas/provider-coder/groups?${buildHeaderQuery(params)}`
  )) as ProviderCoderHeader[];
  return response ?? [];
};

// 7. Snapshot KPI cards (quarter only).
export const fetchProviderCoderKpis = async (
  params: KpiParams
): Promise<ProviderCoderKpis | null> => {
  const response = (await get(
    `/api/v1/risk-areas/provider-coder/kpis?${buildKpiQuery(params)}`
  )) as ProviderCoderKpis;
  return response ?? null;
};
